import { Injectable } from '@angular/core';

@Injectable()
export class AuthTokenService {

  private id_token = "id_token";
  private refresh_token = "refresh_token";
  private access_token = "access_token";

  set setAccessToken(token) {
    localStorage.setItem(this.access_token, token);
  }
  set setIdToken(token) {
    localStorage.setItem(this.id_token, token);
  }
  set setRefreshToken(token) {
    localStorage.setItem(this.refresh_token, token);
  }

  get getAccessToken() {
    let token= localStorage.getItem(this.access_token);
    return token;
  }
  get getRefreshToken() {
    // return localStorage.getItem(this.access_token);
     let token= localStorage.getItem(this.refresh_token);
     return token;
   }
  get getIdToken() {
    // return localStorage.getItem(this.access_token);
     let token= localStorage.getItem(this.id_token);
     return token;
   }

  set saveUser(user) {
    localStorage.setItem("eol_monitor_user", JSON.stringify(user));  
  }

  get getUser(){
    var userDetails=localStorage.getItem('eol_monitor_user'); 
    return userDetails;
  }

  clearTokens() {
    this.access_token="";
    localStorage.removeItem('eol_monitor_access_token');  
    localStorage.removeItem('eol_monitor_user');  
    localStorage.removeItem(this.access_token);  
    localStorage.removeItem(this.id_token);
  }
  
 

}
